import { User as UserModel } from '../es6/models/user'
import { okoPush } from '../helpers/oko-helpers'

/**
 * Инициализация модели пользователя
 */
export const user = new UserModel()
if (window.app && window.app.userJson) {
  user.set(window.app.userJson)
}
if (user.get('is_new_user') && user.id) {
  okoPush({
    'n': 'new-user',
    'user-id': parseInt(user.id, 10),
  })
}
